import queryString from "query-string";
import {
    GET_LIST_COMPARE
} from "../../api/compare/compare";

const state = {
    compare: [],
    compareFilter: [],
    // mode: "",
};

const mutations = {
    SET_COMPARE: (states, payload) => {
        states.compare = payload;
    },
    SET_COMPARE_FILTER: (states, payload) => {
        states.compareFilter = payload;
    },
};

const actions = {
    GET_BUDGET_COMPARE: async ({
        commit
    }, query) => {
        const resp = await GET_LIST_COMPARE(query);
        const data = resp.data.data;
        commit("SET_COMPARE", data);
    },

    GET_BUDGET_COMPARE_FILTER: async ({
        commit
    }, query) => {
        const resp = await GET_LIST_COMPARE(query);
        const data = resp.data.data;
        commit("SET_COMPARE_FILTER", data);
    },
};

const getters = {
    compared: (states) => states.compare,
    comparedFilter: (states) => states.compareFilter,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};